import { IconProps } from '../types';

function ContentClipOutlineIcon({ className, id }: IconProps) {
  return (
    <svg
      id={id}
      xmlns="http://www.w3.org/2000/svg"
      className={className || 'h-5 w-5'}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M20 4v16m-5-4l4-4-4-4m4 4H4"
      />
    </svg>
  );
}

export default ContentClipOutlineIcon;
